import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/bb74bfb/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`United Nations`}<br />{` Department of Economic and Social Affairs`}<br />{` Statistics
Division`}<br />{` Development Data and Outreach Branch`}<br />{` New York, NY
10017`}<br />{` United States`}</p>
    <p>{`E-mail: `}<a parentName="p" {...{
        "href": "mailto:covid-19.stats@un.org"
      }}>{`covid-19.stats@un.org`}</a><br /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      